import { useEffect } from "react";
import { shallowEqual } from "react-redux";
import { bffApi } from "../../../autogen/bff-api";
import { useAppDispatch, useAppSelector } from "../../../common/redux/hooks";

export const useContractTitles = (contractIds: string[]): (string | null | undefined)[] => {
  const dispatch = useAppDispatch();
  const key = contractIds.join(",");

  useEffect(() => {
    const subscriptions = key
      .split(",")
      .filter(Boolean)
      .map((contractId) => dispatch(bffApi.endpoints.getContract.initiate({ contractId })));
    return () => subscriptions.forEach((subscription) => subscription.unsubscribe());
  }, [dispatch, key]);

  return useAppSelector(
    (state) =>
      contractIds.map((contractId) => {
        const result = bffApi.endpoints.getContract.select({ contractId })(state);
        return result.isError ? null : result.data?.title;
      }),
    shallowEqual
  );
};
